export var Name = 'place-order-requested';
export var PlaceOrderRequestedEvent = Name;